module.exports = __webpack_public_path__ + "img/bg-unstoppable-domain.50068b15.png";